/**
 * Container that shifts its size depending on sidebar(s) being open
 *
 */
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import React, {useMemo} from 'react';
import {connect} from 'react-redux';

const Container = ({
  bottom,
  children,
  className,
  dataQe,
  left,
  leftSidebarOpen,
  position,
  right,
  rightSidebarOpen,
  top,
  width,
  sx,
  ...props
}) => {
  const styles = useMemo(
    () => ({
      transition: theme =>
        theme.transitions.create(['margin-left', 'margin-right'], {
          easing:
            leftSidebarOpen || rightSidebarOpen
              ? theme.transitions.easing.easeOut
              : theme.transitions.easing.sharp,
          duration:
            leftSidebarOpen || rightSidebarOpen
              ? theme.transitions.duration.enteringScreen
              : theme.transitions.duration.leavingScreen,
        }),
      marginRight: theme =>
        (rightSidebarOpen && !leftSidebarOpen) ||
        (rightSidebarOpen && leftSidebarOpen)
          ? `${theme.mixins.rightSidebar.width}px`
          : 0,
      marginLeft: theme =>
        (leftSidebarOpen && !rightSidebarOpen) ||
        (rightSidebarOpen && leftSidebarOpen)
          ? `${theme.mixins.leftSidebar.width}px`
          : 0,
    }),
    [leftSidebarOpen, rightSidebarOpen]
  );

  return (
    <Box
      bottom={bottom}
      data-qe={dataQe}
      left={left}
      position={position}
      right={right}
      sx={{...sx, ...styles}}
      top={top}
      width={width}
      {...props}
    >
      {children}
    </Box>
  );
};
Container.propTypes = {
  bottom: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.func,
  ]),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  dataQe: PropTypes.string,
  left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  leftSidebarOpen: PropTypes.bool.isRequired,
  position: PropTypes.oneOf(['absolute', 'fixed', 'relative', 'sticky', null]),
  right: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rightSidebarOpen: PropTypes.bool.isRequired,
  sx: PropTypes.object,
  top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const mapStateToProps = state => ({
  leftSidebarOpen: state.ui.drawers.left !== '',
  rightSidebarOpen: state.ui.drawers.right !== '',
});

export default connect(mapStateToProps, {})(Container);
